import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserPasswordAuthProviderClient, Stitch } from 'mongodb-stitch-browser-sdk';
import { Router } from '@angular/router';
import { ConfirmEmailService } from '../services/confirm-email.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss']
})
export class ConfirmEmailComponent implements OnInit {

  @Input()
  isAlertClosed = true;

  messageToDisplay : any = "";

  constructor(private router: Router,private confirmEmailService : ConfirmEmailService) { }

  ngOnInit() {

    this.confirmEamil();
    this.enableConfirmEmailMessage();


  }

  enableConfirmEmailMessage(){
    this.confirmEmailService.change.subscribe(isOpen => {
      this.isAlertClosed = isOpen;
    });

    this.confirmEmailService.showMessge.subscribe(value => {
      this.messageToDisplay = value;
    });
  }


  confirmEamil(){
    // Parse the URL query parameters
    const url = window.location.search;
    const params = new URLSearchParams(url);
    
    if(params.has('token') && params.has('tokenId')){

      const token = params.get('token');
    const tokenId = params.get('tokenId');
    
    // Confirm the user's email/password account
    const emailPassClient = Stitch.defaultAppClient.auth
      .getProviderClient(UserPasswordAuthProviderClient.factory);
    
    return emailPassClient.confirmUser(token, tokenId)
    .then(res => {
      // this.catchTokenLocally();
       console.log("Done"+res);
       this.messageToDisplay = "Email address is confirmed. Please login to continue";
       this.isAlertClosed = false;
       this.router.navigate(['']);
     }, err => {
      this.isAlertClosed = false;
      this.messageToDisplay = err;
       console.log("Error"+err);
       this.router.navigate(['']);
     });

    }
    
    }

      
      

   /**
   * Close public alert shown to user
   */
  closeAlert() : void {
    this.isAlertClosed = true;
  }


}
